/**
 * Neon arcs for each scene, drawn on a 1440×1024 reference frame and scaled to the viewport.
 *
 * Every scene has the same five slots so the arcs can morph from one scene to the next:
 *   0 left · 1 lower left · 2 top · 3 right · 4 vertical beam
 *
 * d: cubic bézier [x0, y0, c1x, c1y, c2x, c2y, x1, y1]
 * w: stroke width
 * c: gradient stops along the arc (start, middle, end)
 * anchor: 'card' pins the beam's end to the top of the login card
 * clip: 'footer' hides arcs below the footer rule
 */
const collapsed = (x, y, c) => ({ d: [x, y, x, y, x, y, x, y], w: 32, c });

export default {
  intro: {
    clip: 'none',
    arcs: [
      { d: [88, 40, 86, 190, 62, 330, -30, 470], w: 26, c: ['#0A55FF', '#0A86FF', '#16C8FF'] },
      { d: [-40, 640, 60, 750, 140, 880, 200, 1060], w: 30, c: ['#1C6BFF', '#14A8FF', '#1EF0FF'] },
      { d: [690, 40, 900, 200, 1180, 270, 1470, 168], w: 36, c: ['#FF1EEF', '#B02CFF', '#5B35FF'] },
      { d: [1480, 80, 1170, 320, 1150, 690, 1470, 900], w: 34, c: ['#D2ACFF', '#FFF0FF', '#F168FF'] },
      collapsed(720, 40, ['#00F2FF', '#00E2FF', '#00C6FF']),
    ],
  },
  login: {
    clip: 'footer',
    arcs: [
      { d: [-30, 310, 120, 450, 120, 680, -30, 820], w: 34, c: ['#FFE8FF', '#F9BFFF', '#EE84FF'] },
      { d: [-40, 812, 170, 788, 400, 828, 570, 960], w: 38, c: ['#7339FF', '#B12FFF', '#FF20E4'] },
      { d: [600, 40, 820, 240, 1150, 312, 1470, 146], w: 36, c: ['#3B29FF', '#1B6CFF', '#00E8FF'] },
      { d: [1475, 380, 1380, 560, 1310, 760, 1240, 980], w: 34, c: ['#00F0FF', '#1A86FF', '#2638FF'] },
      { d: [738, 40, 738, 150, 738, 250, 738, 340], w: 32, c: ['#00F4FF', '#00E2FF', '#00C8FF'], anchor: 'card' },
    ],
  },
};
